module.exports = {"130229001":"无终街道","130229100":"玉田镇","130229101":"亮甲店镇","130229102":"鸦鸿桥镇","130229103":"窝洛沽镇","130229104":"石臼窝镇","130229105":"虹桥镇","130229106":"散水头镇","130229107":"林南仓镇","130229108":"林西镇","130229109":"杨家板桥镇","130229110":"彩亭桥镇","130229111":"孤树镇","130229112":"大安镇镇","130229113":"唐自头镇","130229114":"郭家屯镇","130229115":"杨家套镇","130229201":"林头屯乡","130229203":"潮洛窝乡","130229204":"陈家铺乡","130229205":"郭家桥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130229.json
// module id = 89
// module chunks = 0